import styles from "./Body.module.css";

const Body = (props) => {
  return <section className={styles.content}>{props.children}</section>;
};

export default Body;